import { useState } from 'react'
import { useApolloClient } from '@apollo/react-hooks'
import {
  GetTubeTotalValidationQuery,
  GetTubeTotalValidationDocument,
} from '@src/queries/ConfiguratorTubesTotalValidationQuery.generated'
import { useProductInput } from './ProductsConfiguration'
import {
  SessionInput,
  TubeTotalValidationResponse,
} from '@src/types/graphql-types'
import useFormikHelper from './useFormikHelper'
interface TubeValidationResponse {
  totalValidationAPI: (
    v: SessionInput[]
  ) => Promise<TubeTotalValidationResponse[]>
  loading: boolean
}

const useTubeTotalValidation = (): TubeValidationResponse => {
  const client = useApolloClient()
  const formik = useFormikHelper()
  const [loading, setLoading] = useState<boolean>(false)
  const productInput = useProductInput()

  const totalValidationAPI = async (
    currentSessionData: SessionInput[]
  ): Promise<TubeTotalValidationResponse[]> => {
    try {
      formik.setFieldValue('loading', true, false)
      setLoading(true)
      const { data } = await client.query<GetTubeTotalValidationQuery>({
        query: GetTubeTotalValidationDocument,
        variables: {
          input: currentSessionData,
          productInput: productInput,
        },
      })
      formik.setFieldValue('loading', false, false)
      setLoading(false)
      return data?.getTubeTotalValidation || []
    } catch (err) {
      setLoading(false)
      return []
    }
  }
  return {
    totalValidationAPI: totalValidationAPI,
    loading: loading,
  }
}

export default useTubeTotalValidation
